import { SnackbarAction } from "notistack";
import { colophonService } from "../../services/colophonService";
import { SystemEntityCollections } from "../../shared/enums/shared-enums";
import { Colophon } from "../../types/colophon";
import { useEntityQueryClient } from "./entityQueryClient";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { extractColophonViewLink } from "../../components/entitiesReferences/InternalEntityLink";
import useColophonLogic from "../logic/colophonLogic";

const useColophonQuery = () => {
  const navigate = useNavigate();
  const { defaultColophon, getDisplayName } = useColophonLogic();
  return useEntityQueryClient<Colophon>({
    service: colophonService,
    collection: SystemEntityCollections.COLOPHON,
    defaultEntity: defaultColophon,
    snackbarDisplayName: getDisplayName,
    snackbarAction: (data: Colophon): SnackbarAction => (
      <Button
        variant="text"
        onClick={() => navigate(extractColophonViewLink(data))}
        sx={{ color: "white" }}
      >
        View Colophon
      </Button>
    ),
  });
};

export default useColophonQuery;
